import { Component, signal } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { RouterOutlet } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  protected readonly title = signal('RedMonk');

  constructor(
    private router: Router,
    private titleService: Title,
    private meta: Meta,
    private activatedRoute: ActivatedRoute
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.applySeoFromRoute();

        if (typeof window !== 'undefined' && typeof (window as any).hidePreloader === 'function') {
          (window as any).hidePreloader();
        }
      }
    });

    this.applySeoFromRoute();
  }

  private applySeoFromRoute(): void {
    let route = this.activatedRoute.root;

    while (route.firstChild) {
      route = route.firstChild;
    }

    const routeData = route.snapshot.data ?? {};
    const pageTitle = routeData['title'] ?? 'Redmonk Wellness, House Of Hydration, Timeless Monk';
    const description =
      routeData['description'] ??
      'IV Therapy is transforming the health and wellness landscape by offering fast, effective solutions tailored to a wide range of wellness and cosmetic needs.';
    const canonicalUrl = routeData['canonicalUrl'] ?? 'https://www.redmonkwellness.com/';

    this.titleService.setTitle(pageTitle);

    this.meta.updateTag({ name: 'description', content: description }, "name='description'");
    this.meta.updateTag({ name: 'robots', content: 'index, follow' }, "name='robots'");
    this.meta.updateTag({ property: 'og:title', content: pageTitle }, "property='og:title'");
    this.meta.updateTag({ property: 'og:description', content: description }, "property='og:description'");
    this.meta.updateTag({ property: 'og:type', content: 'website' }, "property='og:type'");
    this.meta.updateTag({ property: 'og:url', content: canonicalUrl }, "property='og:url'");
    this.meta.updateTag(
      { name: 'twitter:title', content: pageTitle },
      "name='twitter:title'"
    );
    this.meta.updateTag(
      { name: 'twitter:description', content: description },
      "name='twitter:description'"
    );

    if (typeof document !== 'undefined') {
      let canonical = document.head.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;

      if (!canonical) {
        canonical = document.createElement('link');
        canonical.setAttribute('rel', 'canonical');
        document.head.appendChild(canonical);
      }

      canonical.setAttribute('href', canonicalUrl);
    }
  }
}
